@import "@/scss/use-bootstrap-mixins.scss";

.descriptorCard {
  border: 4px solid $primary;
  border-radius: 14px;

  @include media-breakpoint-up(lg) {
    width: 450px;
  }

  .topSection {
    padding: 10px;
    background-color: #fff;
    border-radius: 14px 14px 0 0;

    @include media-breakpoint-up(md) {
      padding: 20px;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        color: #000 !important;
      }

      .booking_details {
        font-weight: 700 !important;
        font-size: 16px;
      }
    }

    .buttons {
      display: flex;
      gap: 8px;
      margin: 12px 0;
      justify-content: space-between;
    }

    .first {
      margin: 0px 0 18px 0;
      display: flex;
      justify-content: space-between;
      gap: 14px;
      align-items: center;

      .size_btn {
        &:hover {
          cursor: pointer;
        }
      }

      .opt_in {
        display: flex;
        gap: 12px;
        align-items: center;
        flex: 1;

        .custom_checkbox {
          position: relative;
          min-width: 21px;
          min-height: 21px;

          .label {
            background-color: #fff;
            width: 21px;
            height: 21px;
            border-radius: 11px;
            cursor: pointer;
            position: absolute;
            border: 1px solid $primaryOnBackground;

            &:after {
              display: initial !important;
              border: 2px solid #fff;
              border-top: none;
              border-right: none;
              content: "";
              height: 6px;
              left: 4px;
              opacity: 0;
              position: absolute;
              top: 6px;
              transform: rotate(-45deg);
              width: 11px;
            }
          }

          input[type="checkbox"] {
            display: none;

            &:checked + label {
              background-color: $primaryOnBackground;
              border-color: $primaryOnBackground;

              &:after {
                opacity: 1;
              }
            }
          }
        }

        .upsell_description {
          display: flex;
          gap: 4px;
          align-items: center;

          .name {
            font-size: 16px;
            display: block;
            font-weight: 500 !important;

            @include media-breakpoint-up(md) {
              font-size: 22px;
            }
          }
        }
      }

      .unit_name {
        font-size: 26px;
        font-weight: 500 !important;
        flex: 1;
      }

      .pricing {
        span {
          display: block;
        }

        .timeframe {
          font-size: 10px;
          font-weight: 600 !important;
          text-align: right !important;
        }

        .price {
          font-weight: 600 !important;
        }
      }
    }

    .addons {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0px;

      .line {
        flex-grow: 1;
        height: 1px;
        background-color: $textColorOnPrimary;
        margin-left: 8px;
      }

      .optional_tag {
        background-color: #f5f5f5;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 600 !important;
        border-radius: 4px;
      }
    }

    .description {
      font-size: 13px;
      font-weight: 400;
      color: #555 !important;
    }
  }

  .deals_header {
    padding: 20px;
    background-color: #fff;

    .header {
      font-weight: 700 !important;
    }

    .coupon_message {
      font-size: 12px;
      text-align: right;
      display: block;

      &.error {
        color: red !important;
      }

      &.success {
        color: green !important;
      }
    }

    .sub_header {
      display: flex;
      flex-direction: column;
      align-items: start;
      margin-bottom: 10px;
      gap: 12px;
      justify-content: space-between;
      align-items: start;

      @include media-breakpoint-up(sm) {
        flex-direction: row;
      }

      .copy {
        font-size: 13px;

        color: #888 !important;
      }

      .coupon {
        display: flex;
        background-color: #f5f5f5;
        border-radius: 4px;
        // padding: 6px;
        align-items: center;
        width: 100%;

        input {
          background-color: transparent;
          border: 0;
          padding: 12px;
          font-size: 11px;
          flex: 1;

          &:focus {
            outline: none !important;
            border: none !important;
            box-shadow: none !important;
          }

          &:disabled {
            opacity: 0.5;
          }
        }

        button {
          background-color: transparent;
          margin-right: 12px;

          &:disabled {
            opacity: 0.5;
          }
        }
      }
    }
  }

  .deals_section {
    // padding: 20px;
    border-top: 4px solid $primary;
    overflow: hidden;

    .deals_body {
      padding: 10px;

      @include media-breakpoint-up(md) {
        padding: 20px;
      }
    }

    .deal_card {
      background-color: #f5f5f5;
      padding: 6px;
      border-radius: 7px;
      border: 2px solid #f5f5f5;

      @include media-breakpoint-up(md) {
        padding: 10px;
      }

      &.active {
        border: 2px solid $primary !important;
      }

      &:not(:last-child) {
        margin-bottom: 10px;
      }

      &:hover {
        cursor: pointer;
      }

      .top_section {
        display: flex;
        align-items: start;
        gap: 8px;

        .opt_in {
          display: flex;
          gap: 12px;
          align-items: center;
          flex-grow: 1;

          .custom_checkbox {
            position: relative;
            min-width: 21px;
            min-height: 21px;

            .label {
              background-color: #fff;
              width: 21px;
              height: 21px;
              border-radius: 11px;
              cursor: pointer;
              position: absolute;
              border: 1px solid $primaryOnBackground;

              &:after {
                display: initial !important;
                border: 2px solid #fff;
                border-top: none;
                border-right: none;
                content: "";
                height: 6px;
                left: 4px;
                opacity: 0;
                position: absolute;
                top: 6px;
                transform: rotate(-45deg);
                width: 11px;
              }
            }

            input[type="checkbox"] {
              display: none;

              &:checked + label {
                background-color: $primaryOnBackground;
                border-color: $primaryOnBackground;

                &:after {
                  opacity: 1;
                }
              }
            }
          }

          .copy {
            display: flex;
            flex-direction: column;

            @include media-breakpoint-up(md) {
              flex-direction: row;
              align-items: center;
              gap: 8px;
            }

            span {
              font-size: 18px;
              display: block;

              &:first-of-type {
              }

              &:last-of-type {
                color: red !important;
                font-size: 14px !important;
              }
            }
          }
        }

        .pricing {
          text-align: right;

          .timeframe {
            display: block;
            font-size: 10px;
            font-weight: 600 !important;
          }

          .price {
            display: block;
            font-size: 16px;
            font-weight: 600 !important;

            @include media-breakpoint-up(md) {
              font-size: 20px;
            }
          }
        }
      }

      .tags {
        display: flex;
        gap: 8px;

        svg {
          height: 1em;
        }
      }

      .deal_description_tag {
        background-color: #fff;
        border-radius: 4px;
        padding: 4px 8px;
        font-size: 12px;
        font-weight: 500 !important;
      }
    }
  }

  .header {
    font-size: 16px !important;
    font-weight: 600 !important;
    color: $textColorOnPrimary;
  }

  .bottom_section {
    padding: 10px;
    border-top: 4px solid $primary;

    @include media-breakpoint-up(md) {
      padding: 20px;
    }

    span.size_text {
      font-size: 14px;
      opacity: 0.8;
      display: block;
      margin-bottom: 12px;
      text-align: center !important;
    }

    .buttons {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      gap: 10px;

      @include media-breakpoint-up(md) {
        flex-direction: row;
        gap: 20px;
      }

      div {
        flex: 1;

        &:last-of-type {
          display: flex;
          flex-direction: column;
          align-items: center;

          span {
            text-decoration: underline;
            color: $primaryOnBackground !important;
            font-size: 14px;
            padding: 4px 0;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
